export default __webpack_public_path__ + "static/media/oneX_Sodium_Borate_Buffer.d74d364e.svg";